const Cancel = function () {
  this.requestUserMeta.resetRequestUserMetaModal()
}

export default Cancel
